module.exports = __webpack_public_path__ + "img/twt.26be8a49.png";